// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"31e3e28e","678":"105ad2fb"}[chunkId] + ".chunk.js";
};